import { apiWrapper } from "@/services/api";

export const postRefundTicket = async (id, params) => {
  let response;
  try {
    response = await apiWrapper(
      "POST",
      `/mfitt/limited_express_tickets/${id}/refund`,
      params
    );
    console.log("postRefundTicket response.data :>> ", response.data);
  } catch (err) {
    console.log('ERROR"" postRefundTicket():', err);
    throw err;
  }
  return response.data;
};
